require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./emplois-tudiants-0-5-3.json") })
        }
      }, "path---emplois-tudiants-0-5-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---emplois-tudiants-0-5-3!./.cache/json/emplois-tudiants-0-5-3.json
// module id = 406
// module chunks = 231608221292675